<template>
<v-container fluid>
    <v-card class="ma-sm-2" flat>
        <v-progress-linear indeterminate color="yellow darken-2" v-if="loading || isExporting"></v-progress-linear>
        <v-card-title class="d-flex">
            <v-btn icon @click="goToProgrammList">
                <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            {{programInfo.name}}
            <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text>{{programInfo.desc}}</v-card-text>
        <v-spacer></v-spacer>
        <program-view-filter @goToLinkMember="goToLinkMember($event)" @toCreateGroupOverview="toCreateGroupOverview($event)" @toExport="toExport($event)" @toExportOnsite="toExportOnsite($event)" :loading="loading" :startDate="startDate" :endDate="endDate" :isExporting="isExporting" :groupId="this.id" :owner="programInfo.owner" :isCoach="isCoach" v-if="this.startDate && this.endDate"/>
    </v-card>
    <v-card class="d-flex ma-sm-2 flex-column flex-md-row flex-sm-row flex-wrap" flat tile v-if="programInfo.isSubmit && !loading && !isExporting && this.startDate && this.endDate">
        <total-summary-component :totalSummaryInfo="totalSummaryInfo" :itemList="itemList" v-if="isShowGroupFilter" />
        <total-summary-component :totalSummaryInfo="totalBehaviorsInfo" :itemList="itemListBehaviors" v-if="isShowGroupFilter" />
        <number-of-users-summary-component :memberNumbers="numberOfRecords" v-if="isShowGroupFilter" />
        <number-of-users-summary-component :memberNumbers="memberNumbers" v-if="isShowGroupFilter" />
        <number-of-users-summary-component :memberNumbers="communication" v-if="isShowGroupFilter" />
        <chart-group-component :chartInfo="agesOfUsers" v-if="isShowGroupFilter" />
        <member-list-component :userList="userList" :startDate="startDate" :endDate="endDate" :exportData="exportData" :owner="programInfo.owner" :isCoach="isCoach" @toCreateGroupOverview="toCreateGroupOverview($event)" />
    </v-card>
    <v-snackbar
      v-model="snackbar"
      multi-line
    >
      {{ text }}

      <template v-slot:actions>
        <v-btn
          color="red"
          variant="text"
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
</v-container>
</template>

<script>
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import {
    mapGetters
} from "vuex";
import formatData from "../utils/formatData";
import getProgramInfoById from '../data/getProgramInfoById';
import ProgramViewFilter from "../components/ProgramViewFilter.vue";
import bqGetProgramSummary from "../data/bqGetProgramSummary";
import TotalSummaryComponent from "../components/TotalSummaryComponent.vue";
import NumberOfUsersSummaryComponent from "../components/NumberOfUsersSummaryComponent.vue";
import MemberListComponent from "../components/ProgramMemberListComponent.vue";
import ChartGroupComponent from "../components/ChartGroupComponent.vue";
import colors from 'vuetify/lib/util/colors';
import bqExportProgramData from "../data/bqExportProgramData";
import bqExportProgramOnsiteData from "../data/bqExportProgramOnsiteData";
import moment from "moment";
import {orderBy} from 'lodash';
import bqGetProgramMemberListById from "../data/bqGetProgramMemberListById";
export default {
    name: 'ProgramView',
    metaInfo: {
        title: 'Program'
    },
    components: {
        ChartGroupComponent,
        ProgramViewFilter,
        TotalSummaryComponent,
        NumberOfUsersSummaryComponent,
        MemberListComponent
    },
    data() {
        return {
            programInfo: {
                // startDate: moment().subtract(10, 'd').format('YYYY-MM-DD'),
                // endDate: moment().format('YYYY-MM-DD')
            },
            //set default date from last 3 month
            isShowGroupFilter: false,
            startDate: '', //moment().subtract(3, 'month').format('YYYY-MM-DD'),
            endDate: '', //moment().format('YYYY-MM-DD'),
            userList: [],
            userListSortByDate: [],
            loading: false,
            isExporting: false,

            numberOfRecords: {
                title: 'Activities',
                labels: [],
                series: [],
                colors: [colors.orange.lighten3, colors.green.lighten3, colors.blueGrey.lighten3, colors.purple.lighten3, colors.cyan.lighten3]
            },
            communication: {
                title: 'Communication',
                labels: [],
                series: [],
                colors: [colors.orange.lighten3, colors.green.lighten3]
            },
            memberNumbers: {
                title: "Participants",
                labels: [],
                series: [],
                colors: [colors.cyan.lighten3, colors.cyan.darken3]
            },
            totalSummaryInfo: {
                title: "Summary",
                data: {
                    onsite: 0,
                    preTest: 0,
                    postTest: 0
                }
            },
            totalBehaviorsInfo: {
                title: "Behaviors (Avg)",
                data: {
                    totalWorkoutMins: 0,
                    totalStep: 0,
                    totalWeightLoss: 0,
                    avgBMI: 0,
                }
            },
            agesOfUsers: {
                chartTitle: "Age groups",
                title: "Age groups",
                noData: true,
                categories: [],
                stacked: true,
                labelsShowX: true,
                labelsShowY: true,
                columnWidth: '80%',
                formatNumber: 0,
                maxY: 0,
                series: [{
                    name: 'Male',
                    data: [],
                    color: colors.cyan.lighten3
                }, {
                    name: 'Female',
                    data: [],
                    color: colors.cyan.darken3
                }]
            },
            chartWeight: {
                chartTitle: "Weight",
                title: "Weight",
                noData: true,
                categories: ["WEIGHT"],
                tickAmount: 3,
                maxY: 80,
                series: [{
                    name: 'Start',
                    color: colors.indigo.lighten3,
                    data: []
                }, {
                    name: 'End',
                    color: colors.indigo.darken3,
                    data: []
                }]
            },
            chartBMI: {
                chartTitle: "BMI",
                title: "BMI",
                noData: true,
                categories: ["BMI"],
                maxY: 35,
                score: 23,
                tickAmount: 2,
                forceNiceScale: true,
                series: [{
                    name: 'Start',
                    color: colors.green.lighten1,
                    data: []
                }, {
                    name: 'End',
                    color: colors.green.darken3,
                    data: []
                }],
                annotations: [{
                    y: 23,
                    borderColor: colors.green.lighten1,
                    offsetX: -5,
                    label: {
                        borderColor: colors.green.darken4,
                        style: {
                            color: "#FFF",
                            background: colors.green.lighten2
                        },
                        text: '23',
                        position: 'left',
                        offsetX: -10,
                        offsetY: 8
                    }
                }]
            },
            chartPressure: {
                chartTitle: "Pressure",
                title: "Pressure",
                noData: true,
                categories: ['Upper', 'Lower'],
                maxY: 150,
                scoreLower: 85,
                scoreUpper: 135,
                columnWidth: '60%',
                tickAmount: 4,
                forceNiceScale: true,
                series: [{
                    name: 'Start',
                    color: colors.deepOrange.lighten3,
                    data: []
                }, {
                    name: 'End',
                    color: colors.teal.darken3,
                    data: []
                }],
                annotations: [{
                    y: 85,
                    borderColor: colors.deepOrange.lighten2,
                    offsetX: -5,
                    label: {
                        borderColor: colors.deepOrange.darken4,
                        style: {
                            color: "#FFF",
                            background: colors.deepOrange.lighten2
                        },
                        text: '85',
                        position: 'left',
                        offsetX: -10,
                        offsetY: 8
                    }
                }, {
                    y: 135,
                    borderColor: colors.teal.lighten2,
                    offsetX: -5,
                    label: {
                        borderColor: colors.teal.darken4,
                        style: {
                            color: "#FFF",
                            background: colors.teal.lighten2
                        },
                        text: '135',
                        position: 'left',
                        offsetX: -10,
                        offsetY: 8
                    },
                }]
            },
            chartLDL: {
                chartTitle: "LDL",
                title: "LDL",
                noData: true,
                categories: ["LDL"],
                maxY: 150,
                score: 130,
                series: [{
                    name: 'Start',
                    color: colors.blue.lighten1,
                    data: []
                }, {
                    name: 'End',
                    color: colors.blue.darken3,
                    data: []
                }],
                annotations: [{
                    y: 130,
                    borderColor: colors.blue.lighten2,
                    offsetX: -5,
                    label: {
                        borderColor: colors.blue.darken4,
                        style: {
                            color: "#FFF",
                            background: colors.blue.lighten2
                        },
                        text: '130',
                        position: 'left',
                        offsetX: -10,
                        offsetY: 8
                    }
                }]
            },
            chartFBS: {
                chartTitle: "FBS",
                title: "FBS",
                noData: true,
                categories: ["FBS"],
                maxY: 150,
                score: 130,
                series: [{
                    name: 'Start',
                    color: colors.pink.lighten3,
                    data: []
                }, {
                    name: 'End',
                    color: colors.pink.darken3,
                    data: []
                }],
                annotations: [{
                    y: 130,
                    borderColor: colors.pink.lighten2,
                    offsetX: -5,
                    label: {
                        borderColor: colors.pink.darken4,
                        style: {
                            color: "#FFF",
                            background: colors.pink.lighten2
                        },
                        text: '130',
                        position: 'left',
                        offsetX: -10,
                        offsetY: 8
                    }
                }]
            },
            itemList: [{
                    key: 'preTest',
                    title: 'PreTest',
                    unit: '',
                    icon: 'account-details-outline',
                    color: colors.teal.lighten4,
                    colorText: colors.teal.darken1
                },
                {
                    key: 'postTest',
                    title: 'PostTest',
                    unit: '',
                    icon: 'account-details',
                    color: colors.deepOrange.lighten4,
                    colorText: colors.deepOrange.darken1
                }, {
                    key: 'onsite',
                    title: 'Avg Onsite',
                    unit: '',
                    icon: 'calendar-account',
                    color: colors.orange.lighten4,
                    colorText: colors.orange.darken1
                },
            ],
            itemListBehaviors: [{
                    key: 'totalWorkoutMins',
                    title: 'Workout',
                    unit: 'mins',
                    icon: 'dumbbell',
                    color: colors.purple.lighten4,
                    colorText: colors.purple.darken1
                }, {
                    key: 'steps',
                    title: 'Steps',
                    unit: '',
                    icon: 'shoe-print',
                    color: colors.orange.lighten4,
                    colorText: colors.orange.darken1
                },
                // {
                //     key: 'totalPBWF',
                //     title: 'PBWF',
                //     unit: 'serves',
                //     icon: 'food-apple',
                //     color: colors.orange.lighten4,
                //     colorText: colors.orange.darken1
                // },
                {
                    key: 'totalWeightLoss',
                    title: 'Weight loss',
                    unit: 'kg',
                    icon: 'scale-bathroom',
                    color: colors.green.lighten4,
                    colorText: colors.green.darken1
                },
                {
                    key: 'avgBMI',
                    title: 'BMI AVG',
                    unit: '',
                    icon: 'triangle-wave',
                    color: colors.pink.lighten4,
                    colorText: colors.pink.darken1
                },
            ],
            exportData: [],
            isCoach: false,
            snackbar: false,
            text: `Convert to Excel failed`,
        };
    },
    created() {
        var vm = this;
        vm.$store.state.appTitle = "Thaisook Web Admin | Coach Program";
        firebase.auth().onAuthStateChanged((user) => {
            if (user) {
                vm.$store.dispatch("autoSignIn", user);
                this.loading = true;
                setTimeout(() => {
                    vm.initialize();
                }, "1000");
            } else {
                console.log("no user");
            }
        });
        //group id
        this.id = this.$route.params.id;
    },
    computed: {

        ...mapGetters([
            "loggedInUserId",
            "isAuthenticated",
            "isSuperAdmin",
            "isChallengeAdmin",
        ])

    },
    methods: {
        initialize() {
            (async () => {
                if (this.loggedInUserId) {
                    this.programInfo = await getProgramInfoById(this.id);
                    if (this.programInfo.coachList != undefined && this.programInfo.coachList.includes(this.loggedInUserId)) {
                        this.isCoach = true;
                    }
                    this.userList = await bqGetProgramMemberListById('program', this.id);
                    if (this.userList.length ) {
                        this.userListSortByDate = orderBy(this.userList, ['startDate.value'], ['asc']);
                        if( this.userListSortByDate[0].startDate != undefined ){
                            this.startDate = moment(this.userListSortByDate[0].startDate.value).format('YYYY-MM-DD');
                        }
                        else{
                            this.startDate = moment().subtract(3, 'month').format('YYYY-MM-DD');    
                        }
                        this.isShowGroupFilter = true;
                    }
                    else{
                        this.startDate = moment().subtract(3, 'month').format('YYYY-MM-DD');
                    }
                    this.endDate = moment().format('YYYY-MM-DD');
                    if( this.startDate && this.endDate ){
                        await this.toCreateGroupOverview({
                            startDate: this.startDate,
                            endDate: this.endDate,
                            isSubmit: true
                        });
                    }
                    // this.loading = false;
                } else {
                    this.$router.push(`/dashboard`);
                }
            })();
        },

        //router
        goToProgrammList() {
            this.$router.push(`/program/program-list`);
        },
        _formatData(type, value) {
            return formatData(type, value);
        },
        calculatePercentChanges(a, b) {
            //get max value
            // return (b-a)/a*100;
            let pc = formatData('number', (b - a) / a * 100);
            if (pc > 0) {
                pc = `+${pc}`;
            }
            return pc;
        },
        calculateMaxY(a, b, maxY, point) {
            //get max value
            let maxValue = b;
            if (a > b) {
                maxValue = a;
            }

            //compare with maxY
            if (maxValue > maxY) {
                maxY = (maxValue * 1) + point;
            }
            return maxY;
        },
        toExport(obj) {
            // this.startDate = obj.startDate;
            // this.endDate = obj.endDate;
            this.isExporting = true;
            (async () => {
                const downloadUrl = await bqExportProgramData(obj.groupId, obj.startDate, obj.endDate);
                if( downloadUrl ){
                    window.location = downloadUrl;
                    this.isExporting = false;
                }
                else{
                    this.snackbar = true;
                    this.isExporting = false;
                }
            })();
        },
        toExportOnsite(obj) {
            this.isExporting = true;
            (async () => {
                const downloadUrl = await bqExportProgramOnsiteData(obj.groupId);
                if( downloadUrl ){
                    window.location = downloadUrl;
                    this.isExporting = false;
                }
                else{
                    this.snackbar = true;
                    this.isExporting = false;
                }
            })();
        },
        goToLinkMember() {
            this.$router.push(`/program/program-list/user/${this.id}`);
        },
        toCreateGroupOverview(obj) {
            this.loading = true;
            this.startDate = obj.startDate;
            this.endDate = obj.endDate;
            this.programInfo.isSubmit = obj.isSubmit;
            if( obj.action == 'delete' ){
                (async () => {
                    this.userList = await bqGetProgramMemberListById('program', this.id);
                })();
            }
            if (obj.isSubmit) {
                (async () => {
                    const programInfoSummary = await bqGetProgramSummary(this.id, obj.startDate, obj.endDate);
                    if (programInfoSummary) {

                        //member 
                        this.memberNumbers.labels = [];
                        this.memberNumbers.series = [];
                        if (programInfoSummary.memberNumbers != undefined) {
                            Object.entries(programInfoSummary.memberNumbers).map(async ([key, item]) => {
                                this.memberNumbers.labels.push(formatData('capitalize', key));
                                this.memberNumbers.series.push(item);
                            });
                        }

                        //Number of records
                        this.numberOfRecords.labels = ['PHR', 'Sleep', 'Drink', 'PBWF', 'Workout'];
                        this.numberOfRecords.series = [
                            programInfoSummary.numberOfRecords.healthData,
                            programInfoSummary.numberOfRecords.sleep,
                            programInfoSummary.numberOfRecords.water,
                            programInfoSummary.numberOfRecords.food,
                            programInfoSummary.numberOfRecords.workout
                        ];

                        //communication
                        this.communication.labels = ['ข้อความโค้ช', 'ข้อความลูกทีม'];
                        this.communication.series = [
                            programInfoSummary.communication.coach,
                            programInfoSummary.communication.member
                        ];

                        //Total Summary
                        this.totalSummaryInfo.data = programInfoSummary.totalSummary;
                        //TOTal Behaviors 
                        this.totalBehaviorsInfo.data = programInfoSummary.totalBehaviors;

                        //ages of users
                        // this.agesOfUsers.data = programInfoSummary.agesOfUsers;
                        this.agesOfUsers.categories = programInfoSummary.agesOfUsers.categories;
                        this.agesOfUsers.series[0].data = programInfoSummary.agesOfUsers.male;
                        this.agesOfUsers.series[1].data = programInfoSummary.agesOfUsers.female;
                        this.agesOfUsers.maxY = programInfoSummary.agesOfUsers.maxY;
                        this.agesOfUsers.noData = false;

                        //chart weight
                        this.chartWeight.noData = true;
                        this.chartWeight.series[0].data = [];
                        this.chartWeight.percent = ''
                        if (programInfoSummary.chartWeight.avgStartWeight) {
                            this.chartWeight.series[0].data[0] = formatData('chart', programInfoSummary.chartWeight.avgStartWeight);
                            this.chartWeight.series[1].data[0] = formatData('chart', programInfoSummary.chartWeight.avgEndWeight);
                            this.chartWeight.percent = this.calculatePercentChanges(
                                programInfoSummary.chartWeight.avgStartWeight,
                                programInfoSummary.chartWeight.avgEndWeight
                            );
                            this.chartWeight.maxY = this.calculateMaxY(
                                programInfoSummary.chartWeight.avgStartWeight,
                                programInfoSummary.chartWeight.avgEndWeight,
                                this.chartWeight.maxY,
                                5
                            );
                            this.chartWeight.noData = false;
                        }
                        //chart BMI
                        this.chartBMI.noData = true;
                        this.chartBMI.series[0].data = [];
                        this.chartBMI.percent = '';
                        if (programInfoSummary.chartBMI.avgStartBMI) {
                            this.chartBMI.series[0].data[0] = formatData('chart', programInfoSummary.chartBMI.avgStartBMI);
                            this.chartBMI.series[1].data[0] = formatData('chart', programInfoSummary.chartBMI.avgEndBMI);
                            this.chartBMI.percent = this.calculatePercentChanges(
                                programInfoSummary.chartBMI.avgStartBMI,
                                programInfoSummary.chartBMI.avgEndBMI,
                            );
                            this.chartBMI.maxY = this.calculateMaxY(
                                programInfoSummary.chartBMI.avgStartBMI,
                                programInfoSummary.chartBMI.avgEndBMI,
                                this.chartBMI.maxY,
                                5
                            );
                            this.chartBMI.noData = false;
                        }

                        //chart pressure
                        this.chartPressure.noData = true;
                        this.chartPressure.series[0].data = [];
                        this.chartPressure.series[1].data = [];
                        this.chartPressure.percent = '';
                        if (programInfoSummary.chartPressure.avgStartPressureUpper) {
                            this.chartPressure.series[0].data[0] = formatData('chart', programInfoSummary.chartPressure.avgStartPressureUpper);
                            this.chartPressure.series[0].data[1] = formatData('chart', programInfoSummary.chartPressure.avgStartPressureLower);
                            this.chartPressure.series[1].data[0] = formatData('chart', programInfoSummary.chartPressure.avgEndPressureUpper);
                            this.chartPressure.series[1].data[1] = formatData('chart', programInfoSummary.chartPressure.avgEndPressureLower);
                            this.chartPressure.percent = this.calculatePercentChanges(
                                programInfoSummary.chartPressure.avgStartPressureUpper,
                                programInfoSummary.chartPressure.avgEndPressureUpper,
                            );
                            this.chartPressure.maxY = this.calculateMaxY(
                                programInfoSummary.chartPressure.avgStartPressureUpper,
                                programInfoSummary.chartPressure.avgEndPressureUpper,
                                this.chartPressure.maxY,
                                15
                            );
                            this.chartPressure.noData = false;
                        }

                        //chart LDL
                        this.chartLDL.noData = true;
                        this.chartLDL.series[0].data = [];
                        this.chartLDL.percent = '';
                        if (programInfoSummary.chartLDL.avgStartLDL) {
                            this.chartLDL.series[0].data[0] = formatData('chart', programInfoSummary.chartLDL.avgStartLDL);
                            this.chartLDL.series[1].data[0] = formatData('chart', programInfoSummary.chartLDL.avgEndLDL);
                            this.chartLDL.percent = this.calculatePercentChanges(
                                programInfoSummary.chartLDL.avgStartLDL,
                                programInfoSummary.chartLDL.avgEndLDL,
                            );
                            this.chartLDL.maxY = this.calculateMaxY(
                                programInfoSummary.chartLDL.avgStartLDL,
                                programInfoSummary.chartLDL.avgEndLDL,
                                this.chartLDL.maxY,
                                20
                            );
                            this.chartLDL.noData = false;
                        }

                        //chart FBS
                        this.chartFBS.series[0].data = [];
                        this.chartFBS.noData = true;
                        this.chartFBS.percent = '';
                        if (programInfoSummary.chartFBS.avgStartFBS) {
                            this.chartFBS.series[0].data[0] = formatData('chart', programInfoSummary.chartFBS.avgStartFBS);
                            this.chartFBS.series[1].data[0] = formatData('chart', programInfoSummary.chartFBS.avgEndFBS);
                            this.chartFBS.percent = this.calculatePercentChanges(
                                programInfoSummary.chartFBS.avgStartFBS,
                                programInfoSummary.chartFBS.avgEndFBS,
                            );
                            this.chartFBS.maxY = this.calculateMaxY(
                                programInfoSummary.chartFBS.avgStartFBS,
                                programInfoSummary.chartFBS.avgEndFBS,
                                this.chartFBS.maxY,
                                20
                            );
                            this.chartFBS.noData = false;
                        }
                        this.exportData = programInfoSummary.rowExport;
                    }

                    this.loading = false;
                })();
            }
        },
        merge(a, b, prop) {
            var reduced = [];
            for (var i = 0; i < a.length; i++) {
                var aitem = a[i];
                var found = false;
                for (var ii = 0; ii < b.length; ii++) {
                    if (aitem[prop] === b[ii][prop]) {
                        found = true;
                        break;
                    }
                }
                if (!found) {
                    reduced.push(aitem);
                }
            }
            return reduced.concat(b);

        }
    }
};
</script>
